import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { createRequestTypes, initialLoading, SIGN_UP_ACTION } from '~/actions';
import { apiMethodsConst } from '~/services/methods';
import { SignUpService } from '../services/SignUpService';
import type { ISignUpRequest, ISignUpResponse } from '../types/SignUp';

const GENERIC_ERROR_MESSAGE = 'Something went wrong, please try again.';

const signUpEvents = createRequestTypes(SIGN_UP_ACTION) as {
  REQUEST: string;
  SUCCESS: string;
  FAILURE: string;
};

export const useSignUp = () => {
  const dispatch = useDispatch();

  return useMutation<ISignUpResponse, unknown, ISignUpRequest>({
    mutationFn: (payload) => SignUpService.signUp(payload),
    onSuccess: (data) => {
      dispatch({ type: apiMethodsConst.AUTH_SIGN_UP_REQUEST, payload: data });
      dispatch(initialLoading());
      // Clear the stashed referral so a later signup on the same device
      // doesn't accidentally re-send it.
      localStorage.removeItem('referralId');
    },
    onError: (error) => {
      const message = error instanceof Error ? error.message : GENERIC_ERROR_MESSAGE;
      dispatch({
        type: signUpEvents.FAILURE,
        payload: { message },
      });
    },
  });
};
